import { render, staticRenderFns } from "./ComposerEditModal.vue?vue&type=template&id=9dad946e"
import script from "./ComposerEditModal.vue?vue&type=script&lang=js"
export * from "./ComposerEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports